import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Icon,
  Separator,
  Stack,
} from '@hurdl/design-system';
import { Palette, SlidersHorizontal } from 'lucide-react';
import { type ReactElement } from 'react';

/**
 * The panel's own appearance and preferences (panel-admin).
 *
 * This is the Admin_Panel's settings, not a per-Product capability page: the panel's
 * appearance and the preferences an operator sets for themselves. The controls the full
 * programme adds are not built in this minimal build, so the page reads as a quiet
 * placeholder rather than an outage — a note on where appearance is governed, and a
 * "coming soon".
 *
 * The one `h1` is the page's; the `main` landmark is the Layout's.
 */
export function SettingsPage(): ReactElement {
  return (
    <Stack gap="large">
      <Stack gap="small">
        <h1 className="font-hurdl-display text-hurdl-heading font-hurdl-semibold">
          Settings
        </h1>
        <p className="text-hurdl-body text-hurdl-muted-foreground">
          How this panel looks and behaves.
        </p>
      </Stack>

      <Card>
        <CardHeader>
          <Stack direction="horizontal" gap="small" align="centre">
            <span className="text-hurdl-muted-foreground">
              <Icon icon={Palette} />
            </span>
            <CardTitle>Appearance</CardTitle>
          </Stack>
          <CardDescription>
            The panel follows your system light or dark preference. A theme
            switcher arrives with the full Admin panel.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Separator className="mb-hurdl-4" />
          <Stack direction="horizontal" gap="small" align="centre">
            <span className="text-hurdl-muted-foreground">
              <Icon icon={SlidersHorizontal} size="small" />
            </span>
            <span className="text-hurdl-muted-foreground">
              More preferences coming soon.
            </span>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
}
